<template>
  <div class="couserView">
    <!-- 专属题库 -->
    <div v-if="ifNew" v-loading="loading" element-loading-text="加载中...">
      <el-collapse v-model="openIndex" accordion @change="collapseChange">
        <el-collapse-item
          v-for="(item, index) in yearsList"
          :key="index"
          :name="index"
        >
          <template slot="title">
            <div class="title">
              <div class="shu"></div>
              <div class="title-name">{{ item.kcName }}</div>
            </div>
            <div class="fenge"></div>
          </template>

          <div class="examPack">
            <div class="list" v-if="courseList && courseList.length > 0">
              <div
                class="item"
                v-for="(examItem, index) in courseList"
                :key="examItem.id || index"
              >
                <div>
                  <img
                    class="item-image"
                    src="https://staticfile.xlcwx.com/m-images/yth/lzjxy/img/study/pager.png"
                  />
                  <div class="item-content w-650">
                    <div class="item-title ellipsis">
                      {{ examItem.paperName }}
                    </div>
                    <div class="item-size ellipsis">
                      <div
                        v-for="(label, labelIndex) in examItem.labelNameList"
                        :key="labelIndex"
                      >
                        {{ label }}
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  class="keep-learn keep-check"
                  @click="
                    answerClick(examItem.contactId)
                  "
                >
                  开始答题
                </div>
              </div>
            </div>
            <div class="nothing" v-else>
              <div class="nothing-text">暂无内容哦~</div>
            </div>
          </div>
        </el-collapse-item>
      </el-collapse>
      <div class="nothing" v-if="!yearsList || yearsList.length === 0">
        <div class="nothing-text">暂无内容哦~</div>
      </div>
    </div>
  </div>
</template>
<script>
import Vue from "vue";
import { getInfo } from "@/api/cookies";
import { HomeClient } from "@/api/home";
const homeClient = new HomeClient();

export default {
  components: {},
  data() {
    return {
      courseList: [], // 课程列表
      yearsList: [], // 数据列表
      openIndex: 0,
      ifNew: true,
      loading: false,
    };
  },
  props: {
    // 课程id
    classesId: {
      type: String,
      required: true
    },
    // 是否购买
    IsPurchase: {
      type: Boolean,
      default: false,
    },
  },
  created() {
    this.getList();
  },
  methods: {
    async getList() {
      this.loading = true;
      try {
        const res = await homeClient.classesButtonKcDataList({
          classesId: this.classesId,
          type: 1
        });

        if (res.code === 0) {
          this.yearsList = res.data || [];
        }

        this.$nextTick(() => {
          this.collapseChange(0);
          this.loading = false;
        });
      } catch (error) {
        console.error("获取课程资料列表失败:", error);
        this.loading = false;
        this.yearsList = [];
      }
    },

    /* 课程展开 */
    async collapseChange(val) {
      if (!val && val !== 0) return;
    
      const item = this.yearsList[val];
      if (!item) return;
    
      this.loading = true;
      try {
        const res = await homeClient.getContactPcPageList({
          oneLabelId: item.productLine,
          kcId: item.id
        });

        this.loading = false;
        if (res.code === 0) {
          this.courseList = res.data || [];
        }
      } catch (error) {
        console.error("获取试卷列表失败:", error);
        this.loading = false;
        this.courseList = [];
      }
    },

    /* 开始答题 */
    answerClick(contactId, paperName, examType) {
      if (!contactId) {
        console.warn("缺少必要的试卷信息");
        return;
      }

      const userInfo = getInfo();
      if (!userInfo) {
        Vue.prototype.goLoginView(false);
        return;
      }
        if(!this.IsPurchase){ 
         this.$notify({
          title: '提示',
          message: '您还没有购买!',
          type: 'warning'
        });
return;
      }
      
      // 使用 Vue.prototype.goExam 方法跳转到答题页面
      Vue.prototype.goExam(      {contactId:contactId,classesId:this.classesId,examType:16}      );
    },
  },
};
</script>
<style lang="less" scoped>
.couserView {
  padding-bottom: 20px;
  background: #fff;
}

/deep/.el-collapse {
  border: none !important;

  .el-collapse-item__header {
    height: 58px;
    padding: 19px 32px 19px 0;
    border: none !important;
    position: relative;

    .title {
      display: flex;
      height: 20px;
      align-items: center;

      .title-name {
        font-size: 18px;
        font-family: Microsoft YaHei-Bold, Microsoft YaHei;
        font-weight: bold;
        color: #333;
        display: flex;
        align-items: center;
        margin-right: 20px;
      }

      .shu {
        width: 4px;
        height: 20px;
        background: #fff;
        border-radius: 0 2px 2px 0;
        opacity: 1;
        margin-right: 29px;
      }
    }

    .fenge {
      height: 1px;
      background: #eeeeee;
      opacity: 1;
      position: absolute;
      bottom: 0;
      left: 32px;
      right: 32px;
    }
  }

  .is-active {
    .shu {
      background: #ff5e51 !important;
    }
  }

  .el-collapse-item__content {
    border: none !important;
    padding-bottom: 0;
  }

  .el-collapse-item__wrap {
    border: none !important;
  }
}

/* 试卷列表 */
.examPack {
  padding: 0 30px;

  .list {
    width: 100%;
    padding: 0;
    background: #ffffff;

    .item {
      position: relative;
      height: 112px;
      border-bottom: 1px solid #eee;
      display: flex;
      align-items: center;
      justify-content: space-between;
      cursor: pointer;
      transition: background-color 0.3s;

      &:hover {
        background-color: #fafafa;
      }

      > div:nth-child(1) {
        display: flex;
        align-items: center;
      }

      .item-image {
        width: 60px;
        height: 80px;
        flex-shrink: 0;
        background: #f7f8f9;
        margin-right: 12px;
      }

      .item-content {
        height: 80px;
        width: 100%;
        display: flex;
        flex-direction: column;
        justify-content: space-between;

        .item-title {
          font-size: 16px;
          font-family: Microsoft YaHei-Regular;
          font-weight: 400;
          color: #333;
          line-height: 24px;
          width: 100%;
        }

        .item-size {
          max-width: 500px;
          display: flex;
          margin-top: 10px;
          overflow-x: hidden;

          > div {
            padding: 1px 4px;
            background: #ffeeed;
            border-radius: 4px;
            font-family: PingFang SC;
            font-weight: 400;
            font-size: 12px;
            color: #ff5e51;
            margin-right: 5px;
          }
        }
      }

      .keep-learn {
        flex-shrink: 0;
      }

      .keep-check {
        // width: 80px;
        height: 32px;
        background: #ff5e51;
        border-radius: 4px;
        color: #fff;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        transition: background-color 0.3s;
        font-size: 14px;

        &:hover {
          background: #ff7a6e;
        }
      }
    }
  }
}

/* 空状态样式 */
.nothing {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 60px 0;

  .nothing-text {
    font-size: 14px;
    color: #999;
  }
}

.w-650 {
  width: 650px !important;
}

/* 省略号样式 */
.ellipsis {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>
